import React, { PropsWithChildren, useContext } from 'react';
import { BillToPayReleaseDetailContext } from './ReleaseDetailProvider.types';
import { useParams } from 'react-router-dom';

const ReleaseDetailContext = React.createContext(
  {} as BillToPayReleaseDetailContext,
);

export function useBillToPayReleaseDetailContext() {
  return useContext(ReleaseDetailContext);
}

export default function BillToPayReleaseDetailProvider(
  props: PropsWithChildren<unknown>,
) {
  const params = useParams<{
    accountPayableId: string;
    installmentPayableId: string;
  }>();

  return (
    <ReleaseDetailContext.Provider
      value={{
        accountPayableId: Number(params.accountPayableId),
        installmentPayableId: Number(params.installmentPayableId),
      }}
    >
      {props.children}
    </ReleaseDetailContext.Provider>
  );
}
